<template>
  <div class="friend-links">
    <h1>{{ $t('links') }}</h1>
    <div class="swiper-container" ref="floor1Swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in list" :key="index" style="
          
            height: 20px;
            margin: 10px;">
          <img :src="item.imgUrlIndex" class="img-url" v-error-img="errorImg" />
        </div>
      </div>

      <div class="swiper-pagination"></div>

      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>

  </div>
</template>

<script>
import { handleRequestFailure } from "@/utils/http";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import errorImg from "@/assets/icon/nodata.png";
import { GetFriendLinkApi } from "@/utils/api";
export default {
  // props: ["list"],
  name: "CarouSel",
  components: {},
  data() {
    return {
      errorImg,
      list: [],
      swiper: null
    };
  },
  watch: {
    //swiper必须要先有结构,但是不能够放在mounted中，v-for的结构可能还没有渲染完
    //此时vuex中的数据还没有被修改。v-for导致轮播图还是静态的
    list: {
      //这里必须使用immediate，因为数组是从父组件传过来的从来没有变过
      //所以使用immediate立即监听
      immediate: true,
      handler() {
        //必须和nexttick一起使用，因为v-for遍历结构需要时间，使用这个可以保证结构渲染完马上
        //产生轮播图
        this.$nextTick(() => {
          // new Swiper(this.$refs.floor1Swiper, {
          //   width: window.innerWidth,
          //   slideToClickedSlide: true,
          //   loop: true, // 循环模式选项
          //   preventClicks: false,
          //   preventClicksPropagation: false,
          //   // 关键配置：允许点击穿透
          //   simulateTouch: false,
          //   allowTouchMove: false,
          //   // 解决快速滑动时的点击失效
          //   shortSwipes: false,
          //   longSwipes: false,
          //   speed: 300,
          //   autoplay: {
          //     delay: 3000,
          //     disableOnInteraction: false,
          //   },
          //   grabCursor: true,
          //   slidesPerView: 10,
          //   // // 如果需要前进后退按钮
          //   // navigation: {
          //   //   nextEl: ".swiper-button-next",
          //   //   prevEl: ".swiper-button-prev",
          //   // },

          //   on: {
          //     click: function (swiper) {
          //       console.log(swiper);

          //       // 获取真实的slide下标
          //       const realIndex = swiper.realIndex;
          //       // 根据真实下标进行页面跳转，这里假设跳转链接在一个数组中
          //       const links = ['link1.html', 'link2.html', 'link3.html'];// 替换为实际的跳转链接数组
          //       window.location.href = links[realIndex];
          //     }
          //   }
          // });
        });
      },
    },
  },
  mounted() {
    this.getFriendLink();
  },
  beforeDestroy() {
    this.swiper && this.swiper.destroy()
  },
  methods: {
    initSwiper() {
      if (this.swiper) return;
      const _this = this  // 保存Vue实例引用
      this.$nextTick(() => {
        this.swiper = new Swiper(this.$refs.floor1Swiper, {
          slideToClickedSlide: true,
          loop: true, // 循环模式选项
          preventClicks: false,
          preventClicksPropagation: false,
          // 关键配置：允许点击穿透
          simulateTouch: true,
          allowTouchMove: false,
          // 解决快速滑动时的点击失效
          shortSwipes: false,
          longSwipes: false,
          speed: 300,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          grabCursor: true,
          slidesPerView: 'auto',
          loopedSlides: 20,
          slideNextTransitionStart: function (swiper) {
          },
          slideNextTransitionEnd: function () {
          },
          // 关键修复：使用Swiper事件代理
          on: {
            click: function (e) {
              // 判断点击目标是否为切换按钮（通过类名）
              const isNavButton = e.target.closest('.swiper-button-prev, .swiper-button-next');
              if (isNavButton) return
              // 获取当前激活slide的真实索引（解决loop模式索引偏移）
              const realIndex = this.realIndex
              // 获取对应的数据链接
              const link = _this.list[realIndex].link
              if (link) {
                window.open(link, '_blank')  // 或 window.location.href = link
              }
            }
          }
        })
      })

    },

    async getFriendLink() {
      try {
        const res = await GetFriendLinkApi({});
        this.list = res;
        this.initSwiper()
      } catch (error) {
        handleRequestFailure(error);
      }
    },
    handleClick(e, item) {
      window.open(item.link, '_blank')
    },
  },
};
</script>

<style scoped lang="scss">
.friend-links {
  height: 200px;
  background-color: rgba(247, 248, 250, 1);
  padding: 30px 40px 54px 40px;
  position: relative;
  overflow: hidden;
  width: 100%;

  h1 {
    font-family: PingFang SC;
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    margin-bottom: 42px;
  }

  .swiper-container::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;

    background-repeat: no-repeat;
    // pointer-events: none;
    /* 避免影响点击事件 */
  }

  .swiper-slide {
    width: auto !important;
    height: 52px !important;
    border-radius: 10px;
    margin-right: 30px;
    border: 1px solid #fff;
    background-color: #fff;
    cursor: pointer;
    pointer-events: auto;
    /* 确保点击事件可触发 */
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    /* 避免被其他元素覆盖 */

  }

  .img-url {
    height: 70%;
    width: 90%;
    background-size: cover;
    background-position: center;
    background-color: #fff;
    object-position: center;
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: 44px;
    height: 44px; // 宽高一致
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    // z-index: 10;
  }

  .swiper-button-prev:after,
  .swiper-container-rtl .swiper-button-next:after {
    content: "prev";
    color: rgba(27, 114, 209, 1);
    display: block;
    font-size: 8px;
  }

  .swiper-button-next:after,
  .swiper-container-rtl .swiper-button-prev:after {
    content: "next";
    color: rgba(27, 114, 209, 1);
    display: block;
    font-size: 8px;
  }

}
</style>
